import React from "react";
import { getAssets } from "@unisearch/helpers";
import Grid from "@mui/material/Grid";
import styles from "./section_with_dropdown.module.scss";
import InfoDropdown from "./components/info_dropdown";

const data = [
  {
    id: 1,
    title: "Screen",
    description:
      "for best-fit students from an active pool of over 1.5 annual visitors in target markets",
  },
  {
    id: 2,
    title: "Connect",
    description:
      "with best-fit prospects and engage one-to-one through multiple communication channels",
  },
  {
    id: 3,
    title: "Convert ",
    description:
      "prospects through a flexible but streamlined recruitment platform, boosting application completion rates",
  },
];

export const UniPageSectionWithDropdown = ({
  data,
  title,
  description,
  image,
  alt,
  imageLeft,
  customClasses,
}) => {
  return (
    <section
      className={`${styles.section_goal} ${
        customClasses?.root ? customClasses.root : ""
      }`}
    >
      <div className="container">
        <Grid container spacing={{ xs: 2, sm: 2, md: 4 }} alignItems="center">
          <Grid item xs={12} sm={12} md={6}>
            <h2 className={styles.title}>{title}</h2>
            <p className={`${styles.sub_title}`}>{description}</p>
            <InfoDropdown
              customClasses={{
                root: styles.dropdown_root,
                dropdown_title_wrapper: styles.dropdown_title_wrapper,
                dropdown_title: styles.dropdown_title,
                dropdown_description_wrapper: styles.dropdown_description_wrapper,
                dropdown_description: styles.dropdown_description,
              }}
              data={data}
              icon="plusMinus"
              borderInside={false}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            style={{ order: imageLeft ? -1 : "" }}
          >
            <div className={styles.image_wrapper}>
              <img src={image} alt={alt} />
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default UniPageSectionWithDropdown;
